// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { StudentInjuryNote, StudentInjuryNoteIncidentLocation, StudentNote } from "../../../Utilities";

export type Base = {
	incidentTime: StudentInjuryNote["incidentTime"] | null;
	incidentLocation: StudentInjuryNote["incidentLocation"] | null;
	wereOtherStudentsCauseOfInjury: StudentInjuryNote["wereOtherStudentsCauseOfInjury"];
	causeOfInjury: StudentInjuryNote["causeOfInjury"];
	medicalAttentionProvided: StudentInjuryNote["medicalAttentionProvided"];
	adultWhoProvidedMedicalAttention: StudentInjuryNote["adultWhoProvidedMedicalAttention"];
	isActionTakenHomeroomTeachersNotified: StudentInjuryNote["isActionTakenHomeroomTeachersNotified"];
	isActionTakenParentNotifiedByPortal: StudentInjuryNote["isActionTakenParentNotifiedByPortal"];
	isActionTakenParentNotifiedByPhone: StudentInjuryNote["isActionTakenParentNotifiedByPhone"];
	isActionTakenParentsRequestedToCollectStudent: StudentInjuryNote["isActionTakenParentsRequestedToCollectStudent"];
	isActionTakenParentNotificationNotNecessary: StudentInjuryNote["isActionTakenParentNotificationNotNecessary"];
	isActionTakenOther: StudentInjuryNote["isActionTakenOther"];
	actionTakenOther: StudentInjuryNote["actionTakenOther"];
	studentNoteID: StudentNote["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "studentNoteID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	incidentTime: null,
	incidentLocation: null,
	wereOtherStudentsCauseOfInjury: false,
	causeOfInjury: "",
	medicalAttentionProvided: "",
	adultWhoProvidedMedicalAttention: "",
	isActionTakenHomeroomTeachersNotified: false,
	isActionTakenParentNotifiedByPortal: false,
	isActionTakenParentNotifiedByPhone: false,
	isActionTakenParentsRequestedToCollectStudent: false,
	isActionTakenParentNotificationNotNecessary: false,
	isActionTakenOther: false,
	actionTakenOther: "",
	studentNoteID: null,
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const incidentLocationOptions = [
	{ value: StudentInjuryNoteIncidentLocation.Cafeteria },
	{ value: StudentInjuryNoteIncidentLocation.Classroom },
	{ value: StudentInjuryNoteIncidentLocation.Garden },
	{ value: StudentInjuryNoteIncidentLocation.Hallways },
	{ value: StudentInjuryNoteIncidentLocation.Playground },
	{ value: StudentInjuryNoteIncidentLocation.SpecialtyClass },
	{ value: StudentInjuryNoteIncidentLocation.Transportation },
];

export type CreateInStudentNote = Omit<Create, "studentNoteID">;

export type CreateInStudentNoteRequiredKey = Exclude<CreateRequiredKey, "studentNoteID">;

export type CreateInStudentNoteSubset<K extends keyof CreateInStudentNote = keyof CreateInStudentNote> = Pick<
	CreateInStudentNote,
	CreateInStudentNoteRequiredKey | K
>;

export const blankItemInStudentNote: CreateInStudentNote = omitKeys(initialCreate, ["studentNoteID"]);
